import React, { Fragment } from 'react';
import { Header, Icon, Image, Segment } from 'semantic-ui-react';

const NotFound = () => {
  return (
    <Fragment>
      <Segment inverted vertical>
        <Header textAlign='center'>
          <Image src='/assets/logo_tour_gold.svg' alt='logo' />
        </Header>
      </Segment>
      <Segment placeholder vertical>
        <Header icon>
          <Icon name='search' />
          ページがみつかりませんでした
        </Header>
      </Segment>
    </Fragment>
  );
};

export default NotFound;
